import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { grey } from '@material-ui/core/colors';
import classNames from 'classnames';

import * as actions from '../actions';

const styles = (theme) => ({
	root: {
		borderTop: `1px solid ${grey[200]}`,
		background: grey[100],
		display: 'flex',
		padding: theme.spacing.unit,
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	icon: {
		fontSize: 18,
	},
	iconNext: {
		marginLeft: theme.spacing.unit
	},
	iconRight: {
		marginRight: theme.spacing.unit
	}
});

class Navigation extends Component {
	constructor(props) {
		super(props);
		this.onNext = this.onNext.bind(this);
		this.onBack = this.onBack.bind(this);
	}

	onNext() {
		const { currentItem, itemsLength, goToNextItem, showResults } = this.props;

		if (currentItem === itemsLength - 1) {
			showResults();
		} else {
			goToNextItem();
		}
	}

	onBack() {
		const { goToPreviousItem } = this.props;

		goToPreviousItem();
	}

	renderBackButton() {
		const { classes, backDisabled } = this.props;
		return (
			<Button onClick={this.onBack} disabled={backDisabled} size="large">
				<i className={classNames('fa', 'fas fa-angle-left', classes.icon, classes.iconRight)} />
				Back
			</Button>
		);
	}

	renderNextButton() {
		const { classes, nextDisabled } = this.props;
		return (
			<Button onClick={this.onNext} disabled={nextDisabled} size="large">
				Next
				<i className={classNames('fa', 'fas fa-angle-right', classes.icon, classes.iconNext)} />
			</Button>
		);
	}

	render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				{this.renderBackButton()}
				{this.renderNextButton()}
			</div>
		);
	}
}

Navigation.propTypes = {
	classes: PropTypes.object.isRequired,
	nextDisabled: PropTypes.bool.isRequired,
	backDisabled: PropTypes.bool.isRequired,
	goToPreviousItem: PropTypes.func.isRequired,
	goToNextItem: PropTypes.func.isRequired,
	showResults: PropTypes.func.isRequired,
	currentItem: PropTypes.number,
	itemsLength: PropTypes.number.isRequired,
};

Navigation.defaultProps = {
	currentItem: null
};

function mapStateToProps({ exercise: { currentItem, itemsLength, items, resultsVisible, recording, wordsPerMinute }, loader: { testMode } }) {
	return {
		itemsLength: items.length,
		currentItem,
		recording,
		backDisabled: recording || currentItem === 0,
		nextDisabled: Boolean(recording || resultsVisible || currentItem === items.length || wordsPerMinute === null)
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps, actions)
)(Navigation);
